export default "__VITE_ASSET__C9PE3gHx__"